<template>
<div style="width: 100%">
	<v-subheader>{{$t('common.all')}}</v-subheader>
	<v-card style="width: 100%">
		<v-data-table
			:headers="headers"
			:items="allPayments"
			hide-actions
		>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.id }}</td>
				<td>{{ props.item.created_at }}</td>
				<td>{{ props.item.worker.firstname }}</td>
				<td>{{ props.item.worker.lastname }}</td>
				<td>{{ $t('payments_types.type_' + props.item.type) }}</td>
				<td>{{ props.item.user.name }}</td>
				<td>{{ props.item.amount }}</td>
				<td>{{ props.item.comment }}</td>
				<td class="text-xs-center">
					<span v-if="props.item.type == 'salary'"></span>
					<v-icon v-else-if="props.item.salary_id" large color="green darken-2">done</v-icon>
					<v-icon v-else large color="blue darken-4">remove</v-icon>
				</td>
				<td>
					<ConfirmDialog class="delete-confirm"
						v-if="hasRole('admin')"
						v-bind="propConfirmDialog"
						@accept="onDeletePay(props.item.id)"
						:tooltip="$t('common.delete')"
					>
							<v-icon dark>delete</v-icon>
					</ConfirmDialog>
				</td>
			</template>
		</v-data-table>
	</v-card>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { HEADERS_TABLE_MAIN_REPORTS } from '../../constants'
import {localeHeadersWorkers} from "../../utils/helpers";
import { notify } from '../../utils/notifications'
import ConfirmDialog from '../../components/ConfirmDialog'

export default {
	components: {
		ConfirmDialog
	},
	data: (vm) => ({
		headers: localeHeadersWorkers(HEADERS_TABLE_MAIN_REPORTS, vm.$t),
		propConfirmDialog: {
			message: vm.$t('workers.confirm_message_pay'),
			title: vm.$t('common.confirm'),
			btnProps: {
				fab: true,
				dark: true,
				small: true,
				color: 'red lighten-2',
			}
		}
	}),
	computed: {
		...mapGetters({ hasRole: 'auth/hasRole' }),
		allPayments() {
			return this.$store.state.reports.allPayments
		}
	},
	methods: {
		...mapActions({
			deletePay: 'workers/deletePay',
			fetchAll: 'reports/fetchAll'
		}),
		onDeletePay(id) {
			this.deletePay(id).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.deleted', { type: this.$t('workers.pay') }),
				})
				this.fetchAll()
			})
		}
	}
}
</script>

<style>
.delete-confirm {
	width: 40px;
	float: right;
}
</style>
